import React from "react";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

export function LogoMark({ size = 34, className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" className={className} aria-hidden="true">
      <rect width="34" height="34" rx="8" fill="#C93646" />
      <rect x="8" y="7" width="7" height="20" rx="1.2" fill="#FFFFFF" />
      <rect x="8" y="20" width="18" height="7" rx="1.2" fill="#FFFFFF" />
      <path d="M18 9h8M18 12.5h8M18 16h8" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ size = 34, light = false, eyebrow, className }) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <LogoMark size={size} />
      <div className="leading-none">
        <p className={cn("font-display font-bold tracking-[.02em] text-[17px]", light ? "text-gold" : "text-navy-2")}>{t("LEONA’S GROUP")}</p>
        {eyebrow && <p className="eyebrow mt-1" style={{ color: "#9FB1C8", fontSize: 10.5 }}>{eyebrow}</p>}
      </div>
    </div>
  );
}
